<template>
  <Btn
    color="gray"
    size="icon"
    :aria-label="isLight ? 'Switch to dark mode' : 'Switch to light mode'"
    @click="colorMode.preference = isLight ? 'dark' : 'light'"
  >
    <MoonIcon v-if="isLight" class="size-6" />
    <LightBulbIcon v-else class="size-6" />
  </Btn>
</template>

<script setup lang="ts">
import LightBulbIcon from '~/components/Icons/LightBulbIcon.vue'
import MoonIcon from '~/components/Icons/MoonIcon.vue'
import Btn from '~/components/UI/Btn.vue'

const colorMode = useColorMode()
const isLight = computed(() => colorMode.value === 'light')
</script>
